<template>
    <div>
        <template v-if="incomplete_attendance === true && data !== null">
            <div class="">
                <div class="attendance-head-bar mb-3 clearfix">
                    <h2 class="float-left"> Incomplete Attendance </h2>
                    <companySettings></companySettings>
                    <router-link to="/uploadBulkAttendance" class="btn btn-primary active mr-2 float-right" v-if="attendance_bulk_upload == true">Attendance bulk upload</router-link>
                </div>
                <div class="attendance-incompletes-calendars mb-3 pt-4 pb-4 pr-5 pl-5">
                    <div class="owl-carousel">
                        <div class="single_calendar" v-for="c in monthsCount" :key="c">
                            <div class="custom_calendar">
                                <!-- Responsive calendar - START -->
                                <div class="responsive-calendar"  :id="`calendar_${c}`">
                                    <div class="controls">
                                        <h4><span data-head-year></span> <span data-head-month></span></h4>
                                    </div>
                                    <div class="day-headers">
                                    <div class="day header">Mon</div>
                                    <div class="day header">Tue</div>
                                    <div class="day header">Wed</div>
                                    <div class="day header">Thu</div>
                                    <div class="day header">Fri</div>
                                    <div class="day header">Sat</div>
                                    <div class="day header">Sun</div>
                                    </div>
                                    <div class="days" data-group="days"></div>
                                </div>
                                <!-- Responsive calendar - END -->
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row calendar-date mb-3 normal-ib-space">
                    <div class="col">
                        <p> {{data.attendance_date | Day_month_first_format}} </p>
                    </div>
                </div>
                <table id="dt" class="table" style="width:100%">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>City</th>
                            <th>Branch</th>
                            <th>Department</th>
                            <th>Arrival</th>
                            <th>Departure</th>
                            <th>Hours</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="u in data.users" :key="u.id">
                            <td class="">
                                <div class="image-title">
                                    <div class="image-holder entity-detail-tooltip" data-toggle="tooltip">
                                        <img :src="u.image_src" alt="" />
                                        <span :class="`attandance-status ${u.attendance_class}`"></span>
                                    </div>
                                    {{u.name}}
                                </div>
                            </td>
                            <td> {{u.city_name}} </td>
                            <td> {{u.branch_name}} </td>
                            <td> {{u.department_name}} </td>
                            <td> {{u.attendance_arrival}} </td>
                            <td> {{u.attendance_departure}} </td>
                            <td> <input type="text" placeholder="hh:mm:AM/PM" class="time_mask form-control" v-mask="{ mask: '##:## AA'}" :id='`date_${u.id}`'/> </td>
                            <td class="text-center">
                                <a href="javascript:;" class="btn btn-primary save-time" @click="updateIncompletes(u.id)"> Save </a>
                            </td>
                        </tr>
                        <tr v-if="data.users.length == 0"><td colspan="8">No record Found.</td></tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template v-else-if="incomplete_attendance === null && data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="incomplete_attendance === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>

    // var shift_id = 0;
    import companySettings from './companySettings';
    export default {
        components: {
            companySettings
        },
        data() {
            return {
                incomplete_attendance : null,
                attendance_bulk_upload : null,
                data : null,
                monthsCount : ['01','02','03','04','05','06','07','08','09','10','11','12'],
                time:null,
                form : new Form({
                    value :  '',
                    uid : '',
                    date : ''
                })
            };
        },
        filters: {
            dateFormate: function(date){
                return moment(date).format('ddd,DD, MMM, YYYY');
            }
        },
        mounted() {
            
            this.$Progress.start();
            this.can('incomplete_attendance|attendance_bulk_upload').then(result => {
                this.incomplete_attendance = result.incomplete_attendance;
                this.attendance_bulk_upload = result.attendance_bulk_upload;
            }).then(result => {
                if(this.incomplete_attendance == true){
                    this.getIncompleteAttendanceData();
                }else{
                    this.$Progress.finish();
                }
            });
            $('.selectpicker').change(function(){
                if(this.value != "all"){
                    myTable.fnFilter(this.value);
                }else{
                    myTable.fnFilter("");
                }
            });

            EventBus.$on('refreshAttendance', data => {
                this.getIncompleteAttendanceData();
            });
        },

        methods: {
            getIncompleteAttendanceData(){
                axios.get('api/attendanceIncompletes')
                .then(res => {
                    if(res.status == 200){
                        this.data = res.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).then(res => {
                    EventBus.$emit('attendanceObject', this.data);
                    this.calendarFunction();
                    this.dataTableFunction();

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },

            checkActive : function(){
                $('.selectpicker').selectpicker('refresh');
                this.isActive = !this.isActive;
            },

            triggerDate(){
                $('#selectedDateHolyDay').click();
            },

            dataTableFunction(){
                var myTable = $("#dt").dataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                "searching":true,
                "processing": true,
                "serverSide": true,
                });
                $('#customSearch').on( 'keyup', function () {
                    myTable.fnFilter(this.value);
                });
            },

            calendarFunction(){
                let that = this;
                $('.owl-carousel').owlCarousel({
                    loop:false,
                    margin:10,
                    nav:true,
                    mouseDrag:false,
                    touchDrag:false,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:3
                        },
                        768:{
                            items:4
                        },
                        1000:{
                            items:4
                        }
                    }
                });

                var obj = this.data.monthly_holidays;
                //loop for getting the monthly holidays
                _.forEach(obj, function(e, i){
                    var events = []; //events array
                    //Inner Loop for getting the Events of holidays for highlights
                    Object.values(e).forEach(value=>{
                        events[value] = {'text': value};
                    })
                    $("#calendar_"+i).responsiveCalendar({
                        time: moment().format('YYYY-'+i) ,
                        events,
                        onDayClick: function(events) {
                            var date = $(this).data('year')+'-'+$(this).data('month')+'-'+$(this).data('day');
                            // if(shift_id != 0){
                            //     var url = 'api/attendanceIncompletes/'+date+'/'+shift_id;
                            // }else{
                                var url = 'api/attendanceIncompletes/'+date;
                            // }
                            that.getIncompleteByDate(url);
                        }
                    });
                });
            },

            getIncompleteByDate(url){
                let that = this;
                this.$Progress.start();
                axios.get(url)
                .then(res => {
                    if(res.status == 200){
                        that.data = res.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).then(res => {
                    that.calendarFunction();
                    that.dataTableFunction();
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },

            updateIncompletes(id){
                var objId = 'date_'+id;
                var value = $('input#'+objId).val();
                if(value == '' || value == null){
                    this.showAlertBox('error','Field is empty please fill');
                     return false;
                }
                var date = this.data.attendance_date;
                this.form.uid = id;
                this.form.date = date;
                this.form.value = value;

                this.form.post('api/updateIncompletes').then(res => {
                    if(res.status == 200){
                        this.getIncompleteAttendanceData();
                        this.showToastBox('success', 'Attendance has been updated');
                    }else{
                        this.showAlertBox('error','Some problem in your form data');
                    }
                }).catch(err => {
                     this.showAlertBox('error','Some problem in your form data');
                });
            }
        },

        destroyed: function() {
            EventBus.$off('refreshAttendance');
        },
    }
</script>
